/**
 * Analogue C# string format
 * interpolate('Lorem {0} dolor {1} amet', 'ipsum', 'sit')
 * @return {String} compiled template
 */
export function interpolate(...args) {
    const [template, ...rest] = args;
    return template.replace(/{(\d+)}/g, (match, number) => (typeof rest[number] !== 'undefined' ?
        rest[number] :
        match));
}

export function interpolateWithPlural(single, plural, number) {
    if (number === 0 || number === 1) {
        return interpolate(single, number);
    }
    return interpolate(plural, number);
}
